import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    opened: {
      color: "green",
      borderColor: "green"
    },
    closed: {
      color: "red",
      borderColor: "red"
    },
    inSetup: {
      color: "orange",
      borderColor: "orange"
    },
    iconButtonMobile: {
      padding: "12px 10px 0 0"
    },
    scanner: {
      "& > div": {
        flex: 1
      }
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    select: {
      display: "flex",
      justifyContent: "center",
      width: 300
    },
    orderItemField: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
    searchField: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3)
    },
    dialogHeader: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      padding: theme.spacing(2)
    }
  })
);
